import { RiHome5Fill, RiHome5Line } from 'react-icons/ri';
import { useLocation, useNavigate } from 'react-router-dom';
import { type JSX } from 'react';
import searchIconActive from '@/assets/svg/static/search-nav-select.svg';
import searchIcon from '@/assets/svg/static/search-nav.svg';
import slaylistIconActive from '@/assets/svg/static/wishlist-nav-select.svg';
import slaylistIcon from '@/assets/svg/static/wishlist-nav.svg';
import useDownloadAppSheetStore from '@/stores/DownloadAppSheetStore';
import useLayoutStore from '@/stores/useLayoutStore';
import styles from './BottomNavbar.module.css';

const HOME_PATH = '/';
const SEARCH_SUGGESTION_PATH = '/search-suggestion';
const SEARCH_PATH = '/search';
const SLAYLIST_PATH = '/slaylist';

const BottomNavbar = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const setIsLayout = useLayoutStore((state) => state.setIsLayout);
  const setIsFocused = useLayoutStore((state) => state.setIsFocused);
  const hide = useLayoutStore((state) => state.hide);
  const { openSheet: openDownloadSheet } = useDownloadAppSheetStore();

  const handleSlaylistClick = (e: React.MouseEvent): void => {
    e.preventDefault();
    handleVibrate();
    const deepLinkUrl = 'slayd://slaylist';
    const timeout = 500;
    window.location.href = deepLinkUrl;
    setTimeout(() => {
      openDownloadSheet('personalize');
    }, timeout);
  };

  const handleHomeClick = (): void => {
    navigate(HOME_PATH);
    handleVibrate();
    setIsFocused(false);
    setIsLayout(true);
  };

  const handleSearchClick = (): void => {
    navigate(SEARCH_SUGGESTION_PATH);
    handleVibrate();
    setIsFocused(true);
    setIsLayout(false);
  };

  const isActive = (path: string): boolean =>
    location.pathname === path || location.pathname.startsWith(`${path}/`);

  const handleVibrate = (): void => {
    if ('vibrate' in navigator) {
      navigator.vibrate(10);
    }
  };

  return (
    <>
      <nav className={`${styles.navbar} ${hide ? styles.hide : ''}`}>
        <div
          className={`${styles.navItem} ${isActive(HOME_PATH) ? styles.active : ''}`}
          onClick={handleHomeClick}
        >
          <div className={styles.iconWrapper}>
            {isActive(HOME_PATH) ? <RiHome5Fill /> : <RiHome5Line />}
          </div>
          <div className={styles.navText}>Home</div>
        </div>

        <div
          className={`${styles.navItem} ${isActive(SEARCH_PATH) || isActive(SEARCH_SUGGESTION_PATH) ? styles.active : ''}`}
          onClick={handleSearchClick}
        >
          <div className={styles.iconWrapper}>
            {isActive(SEARCH_PATH) || isActive(SEARCH_SUGGESTION_PATH) ? (
              <img src={searchIconActive} alt="Search" />
            ) : (
              <img src={searchIcon} alt="Search" />
            )}
          </div>
          <div className={styles.navText}>Search</div>
        </div>
        <div
          className={`${styles.navItem} ${isActive(SLAYLIST_PATH) ? styles.active : ''}`}
          onClick={handleSlaylistClick}
        >
          <div className={styles.iconWrapper}>
            {isActive(SLAYLIST_PATH) ? (
              <img src={slaylistIconActive} alt="Slaylist" />
            ) : (
              <img src={slaylistIcon} alt="Slaylist" />
            )}
          </div>
          <div className={styles.navText}>Slaylist</div>
        </div>
      </nav>
    </>
  );
};

export default BottomNavbar;
